import React, { type FC } from "react";

import cn from "classnames";

import { IconSizeErrorBoundary } from "../../../../../HOCs/IconSizeErrorBoundary";
import { Icon } from "../../../../Icon";

import type { IconProps } from "../../../../Icon";
import type { IButton } from "../../Button";

import classes from "./ButtonIcon.styl";

const BUTTON_ICON_TEST_ID = "button-icon-test-id";

interface IButtonIconMain {
    size: IconProps["size"];
    buttonSize: Exclude<IButton["size"], undefined>;
    /** Отвечает за расположение иконки внутри компонента. Если иконка от RightAddon, то значение будет true. Иначе, false */
    isRight?: boolean;
}

interface IButtonIcon extends Pick<IconProps, "icon"> {}

const ButtonIcon: FC<IButtonIcon> = (_props): JSX.Element => {
    const props = _props as IButtonIcon & IButtonIconMain;
    const { buttonSize, icon, size, isRight } = props;

    return (
        <IconSizeErrorBoundary
            componentName="Button"
            componentSize={buttonSize}
            iconName={icon}
            iconSize={size}
        >
            <Icon
                className={cn(classes["icon"], {
                    [classes[`__right`]]: isRight,
                })}
                {...(props as IconProps)}
                data-tsid={BUTTON_ICON_TEST_ID}
            />
        </IconSizeErrorBoundary>
    );
};

ButtonIcon.displayName = "Button.Icon";

export default ButtonIcon;
